import ApiService from '~/utils/ApiService';
import MetadataService from '~/utils/MetadataService';
import StringService from '~/utils/StringService';
import Helpers from '~/utils/Helpers';
import PermissionsHelper from '~/utils/PermissionsHelper';

export const REQUEST_LOAD_COMPONENT = 'REQUEST_LOAD_COMPONENT';
export const RECEIVE_LOAD_COMPONENT = 'RECEIVE_LOAD_COMPONENT';
export const UPDATE_COMPONENT = 'UPDATE_COMPONENT';
export const UPDATE_TAB = 'UPDATE_TAB';
export const UPDATE_VERSION = 'UPDATE_VERSION';
export const UPDATE_VERSION_TAB = 'UPDATE_VERSION_TAB';
export const LOAD_URL_AND_PARAMS = 'LOAD_URL_AND_PARAMS';
export const REQUEST_VULNERABILITIES = 'REQUEST_VULNERABILITIES';
export const RECEIVE_VULNERABILITIES = 'RECEIVE_VULNERABILITIES';
export const UPDATE_VULNERABILITY_FILTER = 'UPDATE_VULNERABILITY_FILTER';
export const UPDATE_VERSION_FILTER = 'UPDATE_VERSION_FILTER';
export const UPDATE_VERSION_VULNERABILITY_FILTER = 'UPDATE_VERSION_VULNERABILITY_FILTER';
export const UPDATE_COMMITHASH_VULNERABILITY_FILTER = 'UPDATE_COMMITHASH_VULNERABILITY_FILTER';
export const RECEIVE_VERSION_VULNERABILITIES = 'RECEIVE_VERSION_VULNERABILITIES';
export const RECEIVE_COMMITHASH_VULNERABILITIES = 'RECEIVE_COMMITHASH_VULNERABILITIES';
export const REQUEST_VERSION_VULNERABILITIES = 'REQUEST_VERSION_VULNERABILITIES';
export const REQUEST_COMMITHASH_VULNERABILITIES = 'REQUEST_COMMITHASH_VULNERABILITIES';
export const REQUEST_LICENSES = 'REQUEST_LICENSES';
export const RECEIVE_LICENSES = 'RECEIVE_LICENSES';
export const RESET_COMPONENT = 'RESET_COMPONENT';
export const REQUEST_VULNERABLE_VERSIONS = 'REQUEST_VULNERABLE_VERSIONS';
export const RECEIVE_VULNERABLE_VERSIONS = 'RECEIVE_VULNERABLE_VERSIONS';
export const TOGGLE_VULNERABLE_VERSIONS = 'TOGGLE_VULNERABLE_VERSIONS';
export const UPDATE_VERSION_VULNERABILITY_ERRORS = 'UPDATE_VERSION_VULNERABILITY_ERRORS';
export const UPDATE_COMMITHASH_VULNERABILITY_ERRORS = 'UPDATE_COMMITHASH_VULNERABILITY_ERRORS';
export const UPDATE_VULNERABILITY_FETCH_ERROR = 'UPDATE_VULNERABILITY_FETCH_ERROR';
export const UPDATE_FILTER_VALUE = 'UPDATE_FILTER_VALUE';
export const UPDATE_COMMIT_HASH = 'UPDATE_COMMIT_HASH';
export const UPDATE_COMMIT_HASH_TAB = 'UPDATE_COMMIT_HASH_TAB';
export const UDPATE_LATEST_COMMIT_HASHES = 'UDPATE_LATEST_COMMIT_HASHES';
export const UDPATE_LIBRARY_CVSS_SELECTION = 'UDPATE_LIBRARY_CVSS_SELECTION';

export const updateLibraryCvssSelection = cvss => ({
  type: UDPATE_LIBRARY_CVSS_SELECTION,
  cvss,
});

export const requestVulnerableVersions = () => {
  return {
    type: REQUEST_VULNERABLE_VERSIONS,
  };
};

export const receiveVulnerableVersions = vulnerableVersions => {
  return {
    type: RECEIVE_VULNERABLE_VERSIONS,
    vulnerableVersions,
  };
};

export const fetchVulnerableVersions = componentId => {
  return function(dispatch, getState) {
    dispatch(requestVulnerableVersions);
    if (!PermissionsHelper.isOrgPaidOrTrial(getState())) {
      return;
    }

    ApiService.get('/catalog/components/' + componentId + '/versions?filter=vulnerable', {
      shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()),
    }).then(res => {
      dispatch(receiveVulnerableVersions(res));
    });
  };
};

export const toggleOnlyVulnerableVersions = () => {
  return {
    type: TOGGLE_VULNERABLE_VERSIONS,
    meta: {
      snowplow: true,
    },
  };
};

export const requestLicenses = () => {
  return {
    type: REQUEST_LICENSES,
    isLoadingLicenses: true,
  };
};

export const receiveLicenses = licenses => {
  return {
    type: RECEIVE_LICENSES,
    isLoadingLicenses: false,
    licenses,
  };
};

export const updateMetadata = component => {
  MetadataService.setComponentCatalogSEO(component);
};

export const loadLicense = license => {
  return ApiService.get('/licenses/' + license.name).then(res => {
    return res;
  });
};

export const loadLicenses = licenseInfoModels => {
  let promises = licenseInfoModels.map(license => {
    return getLicense(license);
  });

  return Promise.all(promises);
};

export const getLicenses = version => {
  return function(dispatch, getState) {
    dispatch(requestLicenses());
    let store = getState().libraryState;
    const { component } = store;
    const { libraryModel = {} } = component;
    let versions = libraryModel.versions || [],
      activeVersion =
        versions.find(release => {
          return release.version === version;
        }) || {},
      licenseInfoModels = activeVersion.licenseInfoModels || [];

    return loadLicenses(licenseInfoModels).then(function(licenses) {
      return dispatch(receiveLicenses(licenses));
    });
  };
};

export const getLicense = license => {
  return new Promise(function(resolve, reject) {
    const key = 'license-' + license.name;
    if (localStorage.getItem(key) !== null) {
      resolve(localStorage.getItem(key));
    } else if (!license.name) {
      resolve('unknown license');
    } else {
      loadLicense(license).then(res => {
        localStorage.setItem(key, res.fullText);
        resolve(res);
      });
    }
  });
};

export const updateComponent = component => {
  return {
    type: UPDATE_COMPONENT,
    component,
  };
};

export const updateLatestCommitHashes = latestCommitHashes => {
  return {
    type: UDPATE_LATEST_COMMIT_HASHES,
    latestCommitHashes,
  };
};

export const componentVersionUrlBuilder = (endpoint, libraryState, isVeracodeUser) => {
  const { language = '', version = '', component = {}, commitHash = {} } = libraryState;
  const { libraryModel = {} } = component;
  const { links = '', id } = libraryModel;
  // For veracode users, we do not want to rely on HATEOAS links to build the URL
  let requestUrl = isVeracodeUser
    ? `/catalog/components/${id}/${endpoint}?version=${version}`
    : `${links.self}/${endpoint}?version=${version}`;

  if (language.toLowerCase() === 'go' && version === 'HEAD') {
    requestUrl = `${links.self}/${endpoint}?commit_hash=${commitHash}`;
  }

  return requestUrl;
};

export const maybeLoadVersionVulnerabilities = version => {
  return function(dispatch, getState) {
    let store = getState().libraryState;
    const { vulnerabilitiesByVersion, versionVulnerabilityErrors } = store;

    let endpoint = componentVersionUrlBuilder(
      'vulnerabilities',
      store,
      Helpers.isVeracodeUser(getState())
    );

    if (!PermissionsHelper.isOrgPaidOrTrial(getState())) {
      return;
    }

    if (
      Object.keys(vulnerabilitiesByVersion).indexOf(version) === -1 ||
      versionVulnerabilityErrors[version]
    ) {
      dispatch(requestVersionVulnerabilities());
      ApiService.get(endpoint, { shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()) })
        .then(res => {
          dispatch(receiveVersionVulnerabilities(version, res));
        })
        .catch(() => {
          dispatch(receiveVersionVulnerabilities(version, []));
          dispatch(updateVersionVulnerabilityErrors(version, true));
        });
    }
  };
};

export const maybeLoadCommitHashVulnerabilities = commitHash => {
  return function(dispatch, getState) {
    if (!Helpers.isCommitHash(commitHash)) {
      return;
    }

    let store = getState().libraryState;
    const { vulnerabilitiesByCommitHash, commitHashVulnerabilityErrors } = store;

    let endpoint = componentVersionUrlBuilder(
      'vulnerabilities',
      store,
      Helpers.isVeracodeUser(getState())
    );

    if (
      Object.keys(vulnerabilitiesByCommitHash).indexOf(commitHash) === -1 ||
      commitHashVulnerabilityErrors[commitHash]
    ) {
      dispatch(requestCommitHashVulnerabilities());
      ApiService.get(endpoint, { shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()) })
        .then(res => {
          dispatch(receiveCommitHashVulnerabilities(commitHash, res));
        })
        .catch(() => {
          dispatch(receiveCommitHashVulnerabilities(commitHash, []));
          dispatch(updateCommitHashVulnerabilityErrors(commitHash, true));
        });
    }
  };
};

export const receiveVersionVulnerabilities = (version, vulnerabilities) => {
  return {
    type: RECEIVE_VERSION_VULNERABILITIES,
    version,
    vulnerabilities,
  };
};

export const receiveCommitHashVulnerabilities = (commitHash, vulnerabilities) => {
  return {
    type: RECEIVE_COMMITHASH_VULNERABILITIES,
    commitHash,
    vulnerabilities,
  };
};

export const updateVersionVulnerabilityErrors = (version, bool) => {
  return {
    type: UPDATE_VERSION_VULNERABILITY_ERRORS,
    version,
    bool,
  };
};

export const updateCommitHashVulnerabilityErrors = (commitHash, bool) => {
  return {
    type: UPDATE_COMMITHASH_VULNERABILITY_ERRORS,
    commitHash,
    bool,
  };
};

export const requestVersionVulnerabilities = () => {
  return {
    type: REQUEST_VERSION_VULNERABILITIES,
    isLoadingVersionVulnerabilities: true,
  };
};

export const requestCommitHashVulnerabilities = () => {
  return {
    type: REQUEST_COMMITHASH_VULNERABILITIES,
    isLoadingVersionVulnerabilities: true,
  };
};

export const requestLoadComponent = () => {
  return {
    type: REQUEST_LOAD_COMPONENT,
    isLoadingComponent: true,
  };
};

export const receiveLoadComponent = (component, id) => {
  return {
    type: RECEIVE_LOAD_COMPONENT,
    component,
    id,
  };
};

export const updateTab = tab => {
  return {
    type: UPDATE_TAB,
    tab,
  };
};

export const updateVersion = version => {
  return {
    type: UPDATE_VERSION,
    version,
  };
};

export const updateCommitHash = commitHash => {
  return {
    type: UPDATE_COMMIT_HASH,
    commitHash,
  };
};

export const updateVersionTab = versionTab => {
  return {
    type: UPDATE_VERSION_TAB,
    versionTab,
  };
};

export const updateCommitHashTab = commitHashTab => {
  return {
    type: UPDATE_COMMIT_HASH_TAB,
    commitHashTab,
  };
};

export const updateFilterValue = (field, value) => {
  return {
    type: UPDATE_FILTER_VALUE,
    field,
    value,
  };
};

export const getUrl = params => {
  if (!params.title || !params.language || !params.packageManager || !params.componentId) {
    return '';
  }

  const title = (params.title && StringService.sanitizeTitle(params.title)) || '';

  return (
    '/' + title + '/' + params.language + '/' + params.packageManager + '/lid-' + params.componentId
  );
};

export const loadUrlAndParams = (params, baseUrl = '') => {
  const title = (params.title && StringService.sanitizeTitle(params.title)) || '';

  return {
    type: LOAD_URL_AND_PARAMS,
    url: baseUrl + getUrl(params),
    title,
    language: params.language,
    packageManager: params.packageManager,
  };
};

export const resetComponent = () => {
  return {
    type: RESET_COMPONENT,
  };
};

export const maybeLoadComponent = (componentId, withStats = true) => {
  return function(dispatch, getState) {
    let store = getState().libraryState;
    if (!store.component || +store.component.id !== +componentId) {
      dispatch(resetComponent());
      dispatch(requestLoadComponent());

      return ApiService.get(`/v1/libraries/${componentId}?withStats=${withStats}`)
        .then(res => {
          dispatch(updateComponent(res));

          dispatch(receiveLoadComponent(res, componentId));

          dispatch(fetchVulnerableVersions(componentId));
          store = getState().libraryState; // this feels like a bug
          let latestRelease = res.latestRelease;
          if (!store.version) {
            dispatch(updateVersion(latestRelease ? latestRelease.version : ''));
          }

          //If GO, update commit hash to the latest commit hash
          if (res.languageType === 'GO' && !store.commitHash) {
            const { versions = [] } = res;
            const version = versions.find(version => version.version === 'HEAD');
            const latestCommit =
              version && version.latestCommitsPreview && version.latestCommitsPreview[0];
            dispatch(updateCommitHash(latestCommit));
          }
        })
        .then(() => {
          dispatch(fetchVulnerabilities(componentId));
        });
    }
  };
};

export const fetchVulnerabilities = componentId => {
  return function(dispatch, getState) {
    dispatch(requestVulnerabilities());

    if (!PermissionsHelper.isOrgPaidOrTrial(getState())) {
      return;
    }

    ApiService.get(`/catalog/components/${componentId}/vulnerabilities`, {
      shouldUseVeracodeApi: Helpers.isVeracodeUser(getState()),
    })
      .then(res => {
        dispatch(updateVulnerabilityFetchError(false));
        dispatch(receiveVulnerabilities(res));
      })
      .catch(() => {
        dispatch(updateVulnerabilityFetchError(true));
        dispatch(receiveVulnerabilities([]));
      });
  };
};

export const updateVulnerabilityFetchError = bool => {
  return {
    type: UPDATE_VULNERABILITY_FETCH_ERROR,
    bool,
  };
};

export const requestVulnerabilities = () => {
  return {
    type: REQUEST_VULNERABILITIES,
  };
};

export const receiveVulnerabilities = vulnerabilities => {
  return {
    type: RECEIVE_VULNERABILITIES,
    vulnerabilities,
  };
};

export const updateVulnerabilityFilter = filter => {
  return {
    type: UPDATE_VULNERABILITY_FILTER,
    filter,
  };
};

export const updateVersionVulnerabilityFilter = filter => {
  return {
    type: UPDATE_VERSION_VULNERABILITY_FILTER,
    filter,
  };
};

export const updateCommitHashVulnerabilityFilter = filter => {
  return {
    type: UPDATE_COMMITHASH_VULNERABILITY_FILTER,
    filter,
  };
};

export const updateVersionFilter = filter => {
  return {
    type: UPDATE_VERSION_FILTER,
    filter,
  };
};
